import '../css/blocks.css';

import { fadeElements } from './services/ui.service';

/* standard blocks */

import benefits
	from "../../blocks/benefits/benefits";

import ctaNews
	from "../../blocks/cta-news/cta-news";

import ctaOffer
	from "../../blocks/cta-offer/cta-offer";

import ctaService
	from "../../blocks/cta-service/cta-service";

import contentSidebar
	from "../../blocks/content-sidebar/content-sidebar";

import faq
	from "../../blocks/faq/faq";

import featuredIn
	from "../../blocks/featured-in/featured-in";

import generalContent
	from "../../blocks/general-content/general-content";

import heroHome
	from "../../blocks/hero-home/hero-home";

import heroSolidHeader
	from "../../blocks/hero-solid-header/hero-solid-header";

import imageSlider
	from "../../blocks/image-slider/image-slider";

import imageVideo
	from "../../blocks/image-video/image-video";

import listingRestaurants
	from "../../blocks/listing-restaurants/listing-restaurants";

import listingServices
	from "../../blocks/listing-services/listing-services";

import listingVouchers
	from "../../blocks/listing-vouchers/listing-vouchers";

import relatedServices
	from "../../blocks/related-services/related-services";

import sliderImageBackground
	from "../../blocks/slider-image-background/slider-image-background";

import testimonials
	from "../../blocks/testimonials/testimonials";

import testimonialsImageBackground
	from "../../blocks/testimonials-image-background/testimonials-image-background";

import tilesSlider
	from "../../blocks/tiles-slider/tiles-slider";

/* post blocks */




/*
	Run immediately if the document is already parsed - the block editor's
	iframed canvas (ACF Blocks v3 / WP 7.1+) injects this script into an
	already-loaded document, so 'DOMContentLoaded' has already fired there
	and would never trigger the listener below.
*/
function onReady (fn) {
	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', fn);
	} else {
		fn();
	}
}

onReady(function () {

	fadeElements ();

	benefits ();
	ctaNews ();
	ctaOffer ();
	ctaService ();
	contentSidebar ();
	faq ();
	featuredIn ();
	generalContent ();
	heroHome ();
	heroSolidHeader ();
	imageSlider ();
	imageVideo ();
	listingRestaurants ();
	listingServices ();
	listingVouchers ();
	relatedServices ();
	sliderImageBackground ();
	testimonials ();
	testimonialsImageBackground ();
	tilesSlider ();

});
